import Vue from 'vue';
import BzbsApi from '@/core/Http/BzbsApi.js';

export default {
    apiGetUserQuota: function (strBzbsToken, quotaConfigParams) {
        var strUrl = `${Vue.bzbsConfig.bzbsModuleUrl}/profile/privilege`;
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGet(strUrl, strBzbsToken, quotaConfigParams).then(res => {
                var result = res.data

                resolve(result);
            }).catch((error) => {
                reject(error);
            });
        });
    }
}
